import { render, staticRenderFns } from "./DisplayEndDialog.vue?vue&type=template&id=489cde8d&scoped=true&"
import script from "./DisplayEndDialog.vue?vue&type=script&lang=ts&"
export * from "./DisplayEndDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489cde8d",
  null
  
)

export default component.exports